import { makeStyles, css } from '@conexasaude/conexa-hero'
import { RebrandedIllustrationStyle } from './types'

const useStyles = makeStyles<RebrandedIllustrationStyle>({
  illustrationWrapper: (theme, { color, width, height }) => css`
    color: ${color || theme.colors.brand.primary[300]};
    width: ${width};
    height: ${height};
  `,
})

export { useStyles }
